import { styled } from "goober";
import { queries } from "../../../shared/queries";
import { useQuery } from "../../hooks/useQuery";
import { navigate, routes } from "../../lib/urls";
import { Icon } from "../Icon";
import { PressButton } from "../PressButton";
import { Tooltip } from "../Tooltip";

const StorageButton = styled(PressButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px !important;
  border: none;
  cursor: pointer;
  color: var(--text-primary);
  background: var(--alpha4);
  &:hover {
    background: var(--alpha8);
  }
`;

export function PersonalChatVolumesButton() {
  const [volumes] = useQuery(queries.personalVolumes());
  const [personalSpace] = useQuery(queries.personalSpace());

  if (volumes.length === 0 || !personalSpace) return null;

  return (
    <Tooltip content="Browse storage">
      <StorageButton
        onPress={() =>
          navigate(routes.modal.storage, {
            spaceId: personalSpace.id,
            section: "chats",
          })
        }
      >
        <Icon name="box" size={12} />
      </StorageButton>
    </Tooltip>
  );
}
